import "./TodosEmpty.css";

function TodosEmpty() {
  return (
    <p>
      Welcome! 🚀
      <br />
      Start by creating your first To-Do.
    </p>
  );
}

export { TodosEmpty };
